import Collapse from 'bootstrap/js/dist/collapse';

// JS Base
import '../js/index';

// Base SCSS
import '../scss/base.scss';
import '../scss/components/card.scss';
import '../scss/components/carousel.scss';

import '../scss/features.scss';
import '../scss/components/nodes.scss';

import Carousel from '../js/components/carousel';

$(() => {
  if ($('.features-carousel').length) {
    const carousel = new Carousel(
      '.features-carousel',
      {
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        arrows: true,
        autoplay: true,
        adaptiveHeight: true
      },
      {
        768: {
          autoplay: true,
          arrows: true,
          centerMode: true,
          slidesToShow: 1,
        }
      }
    );
    carousel.init();
  }
});
